// extracted by mini-css-extract-plugin
export default {"icon":"PasswordInput_icon__IgNiQ"};